import React, { useEffect, useRef, useState } from 'react';
import { useLocation, useNavigate, useSearchParams } from 'react-router-dom';
import { useLanguage } from '../contexts/LanguageContext';
import ScoutInventoryBrowser from '../components/ScoutInventoryBrowser';
import AppliedJobsList from '../components/AppliedJobsList';
import OpportunitiesHome from '../opportunities/OpportunitiesHome';
import useOpportunityData, { useOpportunityAccess } from '../opportunities/useOpportunityData';
import OpportunityProfilePrompt from '../opportunities/OpportunityProfilePrompt';
// Keep existing public helper imports stable for consumers and tests.
export * from '../opportunities/opportunityData';

export default function OpportunitiesScreen({ user, profile }) {
  const navigate = useNavigate();
  const location = useLocation();
  const [params, setParams] = useSearchParams();
  const { language } = useLanguage();
  const access = useOpportunityAccess();
  const data = useOpportunityData(user, profile, language);
  const [detailsDismissed, setDetailsDismissed] = useState(false);
  const requestedView = params.get('view');
  const view = requestedView === 'applied' ? 'applied' : requestedView === 'browse' || !access.premium ? 'browse' : 'matches';
  const { refresh } = access;
  const previousScout = useRef(null);
  useEffect(() => {
    const scoutKey = `${profile?.primaryScoutId}:${profile?.onboardingCompletionStatus}`;
    if (profile?.primaryScoutId && profile?.onboardingCompletionStatus === 'complete') void refresh({ force: previousScout.current !== null && previousScout.current !== scoutKey });
    previousScout.current = scoutKey;
  }, [profile?.primaryScoutId, profile?.onboardingCompletionStatus, refresh]);
  const openJob = (job, browseState) => navigate(`/job/${encodeURIComponent(job.id)}${view === 'browse' ? '?inventory=1' : ''}`, {
    state: { job, feedView: view, browseState, returnTo: `/opportunities${view === 'matches' ? '' : `?view=${view}`}` },
  });
  return <OpportunitiesHome access={access} view={view} onViewChange={(next) => setParams(next === 'matches' ? {} : { view: next })}
    jobs={data.visibleMatches} onJobClick={openJob} profile={profile} user={user} radar={data.radar} loading={!data.loaded} error={data.error}
    profilePrompt={<OpportunityProfilePrompt user={user} profile={profile} dismissed={detailsDismissed} onDismiss={() => setDetailsDismissed(true)} />}
    searchContent={<ScoutInventoryBrowser user={user} appliedJobIds={data.appliedJobIds} onJobClick={openJob} initialState={location.state?.browseState} />}
    appliedContent={<AppliedJobsList user={user} access={access} interviewJobIds={(data.matches || []).filter((job) => Number(job.fitScore) >= 75).map((job) => job.id)} applications={data.applications} appliedJobIds={data.appliedJobIds} loading={!data.loaded} />} />;
}
